
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/faq",
      function () {
        return require("private-next-pages/wheels/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/faq"])
      });
    }
  